import { uniqueId } from 'lodash'
import React, { SyntheticEvent, useContext, useState } from 'react'
import DotsLoader from 'shared/components/loaders/dots'
import styled from 'styled-components'
import { STILL_MIME_TYPES } from '../../../constants'
import CreationToolGradient from '../../../types/gradient'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import getDownsizedWatermark from '../../../utils/get-downsized-watermark'
import { GradientButton } from '../../buttons'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import API from '../../supercut/shared/utils/api'
import FieldTitle from './field-title'

const api = new API()

const Container = styled.div`
    grid-column: span 2;
`

const FileButton = styled(GradientButton)`
    height: 36px;
    margin-right: 30px;
`

type Props = {
    field: CreationToolSuperCutField
}

const CreationCaptureWatermarkFileField = ({ field }: Props) => {
    const { setWatermark, setPreviousWatermarks } = useContext(CreationCaptureInfoContext)
    const [isLoading, setIsLoading] = useState(false)

    const onFileInput = async (e: SyntheticEvent<HTMLInputElement, Event>) => {
        const { files } = e.currentTarget
        if (files) {
            setIsLoading(true)
            try {
                const watermarkBlob = await getDownsizedWatermark(files[0])
                const watermarkUrl = await api.uploadCaptureAsset(watermarkBlob, 'png')
                const newWatermark = { title: files[0].name, image: watermarkUrl, id: uniqueId('watermark') }
                setWatermark(newWatermark)
                setIsLoading(false)
                setPreviousWatermarks([newWatermark])
                // TODO: Uncomment once previous watermarks is enabled.
                // setPreviousWatermarks([...previousWatermarks, newWatermark])
                // TODO: Remove once previous watermarks is enabled.
            } catch (e) {}
        }
    }

    return (
        <Container>
            {isLoading ? (
                <DotsLoader />
            ) : (
                <>
                    <FieldTitle field={field} />
                    <FileButton colors={CreationToolGradient.colors(CreationToolGradient.IndigoPurple)}>
                        Choose a File
                        <input type="file" accept={STILL_MIME_TYPES.join(',')} onInput={onFileInput} />
                    </FileButton>
                </>
            )}
        </Container>
    )
}

export default CreationCaptureWatermarkFileField
